import { createAsyncAction } from 'typesafe-actions';
import { VerticalDoc } from './types';

export const getVerticalDocs = createAsyncAction(
  'vertical-docs/GET_DOCS_REQUEST',
  'vertical-docs/GET_DOCS_RESPONSE',
  'vertical-docs/GET_DOCS_FAILURE',
)<void, VerticalDoc[], Error>();
